import { styled } from '@linaria/react'
import { SkeletonUnitSC } from 'blocks/Skeletons/components/SkeletonUnit/SkeletonUnit.styled'
import { COLOR, MEDIA } from 'vars/index'

export const PlaylistHeaderSkeletonSC = styled(SkeletonUnitSC)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  padding: 20px 24px;
  background-color: var(${COLOR.SURFACE_OPACITY_LIGHT_10});
`

export const PlaylistSkeletonGradientSC = styled(SkeletonUnitSC)`
  display: flex;
  flex-direction: column;
  padding: 24px;
`

export const PlaylistTitleSkeletonSC = styled(SkeletonUnitSC)`
  width: 250px;
  height: 24px;
  background-color: var(${COLOR.SURFACE_OPACITY_LIGHT_20});
`

export const CloseBtnSkeletonSC = styled(SkeletonUnitSC)`
  height: 24px;
  width: 24px;
  background-color: var(${COLOR.SURFACE_OPACITY_LIGHT_15});

  ${MEDIA.MIN_600} {
    display: none;
  }
`

export const PlaylistImageSkeletonSC = styled(SkeletonUnitSC)`
  width: 160px;
  height: 90px;
  margin-bottom: 40px;
`

export const PlaylistItemTitleSkeletonSC = styled(SkeletonUnitSC)`
  width: 86px;
  height: 24px;
  margin: 20px 0 4px 24px;
`

export const PlaylistItemSubTitleSkeletonSC = styled(SkeletonUnitSC)`
  width: 175px;
  height: 24px;
  margin: 0 0 4px 24px;
`
